export default {
    title: '帳號申請'
}
